import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { siteInfo } from '@/mocks/siteInfo';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Brand */}
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="font-heading text-xl text-background-50">
                韩漫之家
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              致力于为中文读者提供最全面、最优质的韩国漫画在线阅读服务。每日更新，海量资源，让阅读更精彩。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  {t('nav.categories')}
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  {t('nav.about')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/category/romance" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">恋爱</Link>
              </li>
              <li>
                <Link to="/category/action" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">动作</Link>
              </li>
              <li>
                <Link to="/category/fantasy" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">奇幻</Link>
              </li>
              <li>
                <Link to="/category/thriller" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">悬疑</Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">{t('about.contactTitle')}</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-mail-line text-base"></i>
                <span>{siteInfo.email}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-phone-line text-base"></i>
                <span>{siteInfo.phone}</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-400">
                <i className="ri-map-pin-line text-base mt-0.5"></i>
                <span>{siteInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 md:mt-12 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">{t('footer.copyright')}</p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors duration-200">{t('footer.privacy')}</a>
            <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors duration-200">{t('footer.terms')}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}